import { useContext, useState } from 'react';
import { AppContext } from '../../../context';

interface Props {
    name: string;
    disable?: boolean;
    onChange: (value: string) => void;
    value: string | undefined | number;
    label?: string;
}

export const InterruptionReferenceTableSelector = ({
    name,
    onChange,
    disable = false,
    value,
    label,
}: Props) => {
    const { langResources, interruptionReferenceTypesList } = useContext(AppContext);

    const handlerInputChange = (e: any) => {
        onChange(e.target.value);
    };

    return (
        <>
            <select
                name='reference'
                id='reference-selector'
                className='form-select form-select-sm text-dark'
                title={label}
                onChange={(e) => handlerInputChange(e)}
                defaultValue={value}
                placeholder={'Seleccionar referencias de interrupciones'}
                style={{ height: 35 }}
            >
                <option value={-1} key={-1} defaultValue={value}>
                    -- Seleccionar --
                </option>
                {interruptionReferenceTypesList.map((irt) => (
                    <option value={irt.id} key={irt.id}>
                        {irt.name}
                    </option>
                ))}
            </select>
        </>
    );
};
